export default "__VITE_PUBLIC_ASSET__9f513b04__"